<template>
<div class="chapter">
<div class="inner_page">
<p class="front-title"><a id="page_vi"></a><a id="page_vii"></a><b>Illustrations</b></p>
<div class="hang">
<p class="hangindenta" id="rplat_01"><span href="#/19_plate_section#plat_01" title="Link target outside of Sample">Looking into Garbh Choire Mòr.</span></p>
<p class="hangindenta" id="rplat_02"><span href="#/19_plate_section#plat_02" title="Link target outside of Sample">The interior of Ruigh-aiteachain bothy.</span></p>
<p class="hangindenta" id="rplat_03"><span href="#/19_plate_section#plat_03" title="Link target outside of Sample">The two engines of the Oxford Mk I on a spur of Beinn a’ Bhuird.</span></p>
<p class="hangindenta" id="rplat_04"><span href="#/19_plate_section#plat_04" title="Link target outside of Sample">The Shelter Stone Crag and Cairn Etchachan.</span></p>
<p class="hangindenta" id="rplat_05"><span href="#/19_plate_section#plat_05" title="Link target outside of Sample">The Shelter Stone.</span></p>
<p class="hangindenta" id="rplat_06"><span href="#/19_plate_section#plat_06" title="Link target outside of Sample">The path between Ben Macdui and Loch Etchachan.</span></p>
<p class="hangindenta" id="rplat_07"><span href="#/19_plate_section#plat_07" title="Link target outside of Sample">Looking down on the El Alamein Refuge and the slopes of Strath Nethy.</span></p>
<p class="hangindenta" id="rplat_08"><span href="#/19_plate_section#plat_08" title="Link target outside of Sample">The inscription on the El Alamein Refuge, bearing the insignia of the Highland Division.</span></p>
<p class="hangindenta" id="rplat_09"><span href="#/19_plate_section#plat_09" title="Link target outside of Sample">The ruins of Slugain Lodge in Upper Gleann an t-Slugain, the Fairy Glen.</span></p>
<p class="hangindenta" id="rplat_10"><span href="#/19_plate_section#plat_10" title="Link target outside of Sample">A small stone tablet, once part of the St Valery refuge and inscribed with its name.</span></p>
<p class="hangindenta" id="rplat_11"><span href="#/19_plate_section#plat_11" title="Link target outside of Sample">The Sappers’ Bothy near the summit of Ben Macdui.</span></p>
<p class="hangindenta" id="rplat_12"><span href="#/19_plate_section#plat_12" title="Link target outside of Sample">The surreal granite tors on the vast expanse of the Ben Avon plateau.</span></p>
<p class="hangindenta" id="rplat_13"><span href="#/19_plate_section#plat_13" title="Link target outside of Sample">Looking south into the wide breach of the Lairig Ghru from Braeriach.</span></p>
<p class="hangindenta" id="rplat_14"><span href="#/19_plate_section#plat_14" title="Link target outside of Sample">The Lairig Ghru, looking north, with the Devil’s Peak in the centre.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_illustrations.vue?726753e6